import { z } from 'zod';

/*
    https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#ratenschutzabsicherung

    {
        gewuenscht: Boolean,
        kommentar: String,
        vorhanden: Boolean,
        wichtig: Boolean
    }

*/
export const schemaEuropaceRatenschutzAbsicherung = z.object({
    gewuenscht: z.optional(z.boolean()),
    kommentar: z.optional(z.string()),
    vorhanden: z.optional(z.boolean()),
    wichtig: z.optional(z.boolean()),
});

export type SchemaEuropaceRatenschutzAbsicherung = z.infer<typeof schemaEuropaceRatenschutzAbsicherung>;
